import { useQuery } from '@tanstack/react-query';
import { sourcesApi } from '../api/sources.api';
import type { SourceDetail } from '../types/sources.types';
import { sourceKeys } from './queryKeys';

export const useSourceDetail = (id: string | undefined) => {
  const { data, isLoading } = useQuery({
    queryKey: sourceKeys.detail(id!),
    queryFn: () => sourcesApi.getSourceById(id!),
    enabled: !!id,
    staleTime: 1000 * 60 * 2,
  });

  return {
    source: data?.data as SourceDetail | undefined,
    isLoading,
  };
};
